import { render, staticRenderFns } from "./ComprobanteCompra.vue?vue&type=template&id=78a9f3b8&"
import script from "./ComprobanteCompra.vue?vue&type=script&lang=js&"
export * from "./ComprobanteCompra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports